// Shorthand only
module.exports = require('./dist/enable-bb')
